import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { initCartItems, selectAvailableProducts } from '../../cart/shared/reducers/cart.slice';

import { CART_PATH, getPageUrl } from '../constant';
import { useAppSelector } from '../store';

import { amplitudeService } from '../amplitude';
import { SelectCart } from '../amplitude/events';

export function useCartButton() {
  const router = useRouter();
  const dispatch = useDispatch();

  const { cartItems } = useAppSelector(({ cart }) => cart);
  const { hasSession } = useAppSelector(({ auth }) => auth);
  const availableProducts = useAppSelector(selectAvailableProducts);

  const moveCart = () => {
    amplitudeService.logEvent(new SelectCart());

    if (router.pathname === CART_PATH.cart.uri) {
      router.reload();
      return;
    }

    router.push(getPageUrl(CART_PATH.cart), CART_PATH.cart.uri);
  };

  useEffect(() => {
    if (!hasSession || !router.isReady) {
      return;
    }

    dispatch(initCartItems());
  }, [hasSession, dispatch, availableProducts.length, router.isReady]);

  useEffect(() => {
    // beCache 가 발생하면 effect 가 발생하지 않아 장바구니가 초기화 되지 않기 때문에 추가함
    window.addEventListener('pageshow', (event) => {
      if (!hasSession || !event.persisted) {
        return;
      }

      dispatch(initCartItems());
    });
  }, [dispatch, hasSession]);

  return {
    basketCount: cartItems.length,
    moveCart,
  };
}
